import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslocoModule } from '@jsverse/transloco';
import { RegistrationComponent } from './registration.component';
import { RgSignupComponent } from './components/rg-signup/rg-signup.component';
import { RgOtpVerficationComponent } from './components/rg-otp-verfication/rg-otp-verfication.component';
import { RgAddressComponent } from './components/rg-address/rg-address.component';
import { RgCasinoAccComponent } from './components/rg-casino-acc/rg-casino-acc.component';
import { RgForgotPasswordComponent } from './components/rg-forgot-password/rg-forgot-password.component';
import { RgChangePasswordComponent } from './components/rg-change-password/rg-change-password.component';
import { RgCasinoAccPinComponent } from './components/rg-casino-acc-pin/rg-casino-acc-pin.component';


@NgModule({
  declarations: [
    RegistrationComponent,
    RgSignupComponent,
    RgOtpVerficationComponent,
    RgAddressComponent,
    RgCasinoAccComponent,
    RgForgotPasswordComponent,
    RgChangePasswordComponent,
    RgCasinoAccPinComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslocoModule,
  ],
  exports: [
    RegistrationComponent,
    RgSignupComponent,
    RgOtpVerficationComponent,
    RgAddressComponent,
    RgCasinoAccComponent,
    RgForgotPasswordComponent,
    RgChangePasswordComponent,
    RgCasinoAccPinComponent
  ]
})
export class RegistrationModule { }
